module.exports = __webpack_public_path__ + "static/media/coopervision.e30b9509.png";